import { IonButton, IonHeader, IonInput, IonModal, IonSpinner, IonToolbar } from "@ionic/react";
import { Group } from "../utils/Interfaces";
import "../theme/GlobalStyles.css";
import { useContext, useState } from "react";
import { APIService } from "../network/APIService";
import AppContext from "../providers/AppContext";

const EditGroupModal = ({
  modalTitle,
  selectedGroup,
  handleModalDismiss,
}: {
  modalTitle: string;
  selectedGroup?: Group;
  handleModalDismiss: () => void;
}) => {
  const appContext = useContext(AppContext);

  const [makingChanges, setMakingChanges] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [groupName, setGroupName] = useState<string>(selectedGroup ? selectedGroup.name : "");

  const handleSaveChanges = async () => {
    setMakingChanges(true);
    if (selectedGroup) {
      // update existing user
      const editedGroup = await APIService.editGroup(appContext.jwt, groupName, selectedGroup.id);
      if (editedGroup) {
        setErrorMessage("");
        handleModalDismiss();
      } else {
        setErrorMessage("Failed to save changes.");
      }
    } else {
      // create new user
      const addedNewGroup = await APIService.createGroup(appContext.jwt, groupName);
      if (addedNewGroup) {
        setErrorMessage("");
        handleModalDismiss();
      } else {
        setErrorMessage("Failed to save changes.");
      }
    }
    setMakingChanges(false);
  };

  return (
    <IonModal
      backdropDismiss={!makingChanges}
      onDidDismiss={handleModalDismiss}
      isOpen={true}
      className="editGroupModal"
    >
      <IonHeader>
        <IonToolbar>
          <div className="modalToolbarContent">
            <div className="modalToolbarSides" />
            <p>{modalTitle}</p>
            {makingChanges ? (
              <div className="modalToolbarSides">
                <IonSpinner name="bubbles" />
              </div>
            ) : (
              <div className="modalToolbarSides" />
            )}
          </div>
        </IonToolbar>
      </IonHeader>
      <div id="editGroupModalMainContent">
        <p style={{ color: "black", marginBottom: "8px" }} className="tableOptionsText">
          Group name
        </p>
        <IonInput
          value={groupName}
          style={{
            color: "black",
            fontFamily: "av-demi-bold",
            fontSize: "15px",
          }}
          onIonChange={e => setGroupName(e.detail.value!)}
          type="text"
        />
        {errorMessage !== "" && <p className="modalErrMessage">{errorMessage}</p>}
      </div>
      <div className="modalFooterButtonsContainer">
        <IonButton
          disabled={makingChanges || groupName === ""}
          id="saveEditGroupChangesBtn"
          className="yellowBtn"
          onClick={handleSaveChanges}
        >
          Save changes
        </IonButton>
      </div>
    </IonModal>
  );
};

export default EditGroupModal;
